import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../api";

import Project from "../components/Project.js";
import ProjectController from "../components/ProjectController.js";
import Header from "../components/Header.js";
import Draggable from "../components/Draggable.js";
import LoadingAnimation from "../components/LoadingAnimation.js";

import GetRandomGridTemplate from "../hooks/getRandomGridTemplate.js";
import SetFavicon from "../hooks/changeFavIcon.js";

function Work({ headerPressed, setAppWorkColours, workInfo, lastProjectIndex, setLastProjectIndex }) {
  const [currentProjectTitle, setCurrentProjectTitle] = useState(null);
  const [currentProjectYears, setCurrentProjectYears] = useState({});
  const [currentProjectIndex, setCurrentProjectIndex] = useState(lastProjectIndex ? lastProjectIndex : 0);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [lastTemplateIndex, setLastTemplateIndex] = useState(null);

  const [isNextProject, setIsNextProject] = useState(null);
  const [projectIsEntering, setProjectIsEntering] = useState(false);
  const [projectIsExiting, setProjectIsExiting] = useState(false);

  const { slug } = useParams();

  const navigate = useNavigate();

  const setRandomTemplate = () => {
    const newTemplateInfo = GetRandomGridTemplate(lastTemplateIndex);
    setLastTemplateIndex(newTemplateInfo.index);
    setCurrentTemplate(newTemplateInfo.template);
  };

  useEffect(() => {
    setRandomTemplate();
    setProjectFromSlug(workInfo, slug);
  }, []);

  const setProjectFromSlug = (projects, slug) => {
    const index = projects.findIndex(
      (project) => slugify(project.acf.title) === slug
    );

    const project = index !== -1 ? projects[index] : null;

    if (project) {
      setCurrentProject(project);
      setCurrentProjectIndex(index);
      setLastProjectIndex(index);
    } else if (
      currentProjectIndex
    ) {
      setCurrentProject(projects[currentProjectIndex]);
      setLastProjectIndex(currentProjectIndex);
    } else {
      setCurrentProjectIndex(0);
      setCurrentProject(projects[0]);
      setLastProjectIndex(0);
    }
  };

  const slugify = (str) => {
    return str
      .toLowerCase() // Convert to lowercase
      .trim() // Remove leading/trailing spaces
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .replace(/[^\w_]/g, ""); // Remove non-word characters (except underscore)
  };

  const changeSlug = (newSlug) => {
    navigate(`/work/${newSlug}`, { replace: true });
  };

  const setCurrentProject = (projectInfo) => {
    changeSlug(slugify(projectInfo.acf.title));
    const colours = {
      background: projectInfo.acf.background_colour,
      text: projectInfo.acf.text_colour,
    };
    SetFavicon(colours);
    setAppWorkColours(colours);
    setCurrentProjectTitle(projectInfo.acf.title);
    setCurrentProjectYears({
      start: projectInfo.acf.start_year,
      end: projectInfo.acf.end_year,
    });
  };

  //runs when next or previous project button is pressed
  const handleProjectChange = (isNext) => {
    //prevent rapid changes
    if (projectIsEntering || projectIsExiting) return;

    setIsNextProject(isNext);

    setProjectIsExiting(true);

    return;
  };

  //runs once project has exited (exit animation has ended)
  const handleProjectExit = () => {
    var newIndex = currentProjectIndex;

    if (isNextProject) {
      newIndex++;
      if (newIndex >= workInfo.length) {
        newIndex = 0;
      }
    } else {
      newIndex--;
      if (newIndex < 0) {
        newIndex = workInfo.length - 1;
      }
    }

    setCurrentProjectIndex(newIndex);
    setLastProjectIndex(newIndex);
    setCurrentProject(workInfo[newIndex]);
    setRandomTemplate();

    setTimeout(setProjectIsExiting(false), 500);
  };

  return (
    <>
      <Header headerPressed={headerPressed} isWork={true} />

      {(workInfo && currentProjectIndex != null && currentTemplate) ? (<Project
        info={workInfo[currentProjectIndex].acf}
        template={currentTemplate}
        key={currentProjectIndex}
        exiting={projectIsExiting}
        isNext={isNextProject}
        onExitingDone={handleProjectExit}
      />) : ('')}

      <ProjectController
        projectTitle={currentProjectTitle}
        projectYears={currentProjectYears}
        onProjectChange={handleProjectChange}
        exiting={projectIsExiting}
      />
    </>
  );
}

export default Work;
